import React, { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { onUpdateAvailable, applyUpdate } from '@/lib/appUpdater';

// Non-intrusive banner: the user decides when to reload, so unsaved forms are never lost
export const UpdateBanner = () => {
  const [visible, setVisible] = useState(false);
  const [applying, setApplying] = useState(false);

  useEffect(() => onUpdateAvailable(() => setVisible(true)), []);

  if (!visible) return null;
  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 top-3 z-[70] w-[calc(100vw-2rem)] sm:w-auto rounded-xl border border-primary/40 bg-card/95 backdrop-blur-md shadow-2xl px-4 py-3 flex items-center gap-3 animate-in slide-in-from-top-2"
      role="status"
      data-testid="update-banner"
    >
      <RefreshCw className={`w-4 h-4 text-primary shrink-0 ${applying ? 'animate-spin' : ''}`} />
      <div className="text-sm">
        <p className="font-medium">Nova versão disponível</p>
        <p className="text-xs text-muted-foreground">Termine o que está fazendo e atualize quando quiser.</p>
      </div>
      <Button
        size="sm"
        className="ml-2"
        disabled={applying}
        onClick={() => { setApplying(true); applyUpdate(); }}
        data-testid="update-banner-apply-btn"
      >
        Atualizar
      </Button>
      <Button size="icon" variant="ghost" className="h-7 w-7" onClick={() => setVisible(false)} title="Depois" data-testid="update-banner-dismiss-btn">
        <X className="w-4 h-4" />
      </Button>
    </div>
  );
};
